import React from 'react';
import ParticleBackground from '../particle/ParticleBackground';
import { Link } from 'react-router-dom'
function Layout(props) {
  return (
    <React.Fragment>

      <div className="backgroundParticles"> <ParticleBackground /> </div>

      <div className="container">
        <div className="menu">
          <nav>
            <ul>
              <li><Link to="/porfolio-v2.0" className="Link" ><div className="iconNav about">xxx</div> <span className="lel">About me </span></Link></li>
              <li><Link to="/Proyects" className="Link"><div className="iconNav proyect">xxx</div><span className="lel">Proyects</span></Link></li>
              <li><Link to="/Contact" className="Link"><div className="iconNav contact">xxx</div><span className="lel">Contact</span></Link></li>
            </ul>


            <div className="socialicons">
              <a href="https://www.linkedin.com/in/jamesgrimaldo/" target="_blank" rel="noreferrer">
                <div className="id social"> </div>
              </a>

              <a href="https://" target="_blank" rel="noreferrer">
                <div className="ig social"> </div>
              </a>

              <a href="https://" target="_blank" rel="noreferrer">
                <div className="fb social"> </div>
              </a>

              <a href="https://" target="_blank" rel="noreferrer">
                <div className="tw social"> </div>
              </a>

              <a href="https://" target="_blank" rel="noreferrer">
                <div className="ws social"> </div>
              </a>

            </div>



          </nav>

        </div>

        {props.children}
      </div>






    </React.Fragment>
  );
}
export default Layout;